import React from 'react';
import { cn } from '@/lib/utils';

interface GlassSurfaceProps extends React.HTMLAttributes<HTMLDivElement> {
    variant?: 'panel' | 'card' | 'elevated';
    hoverEffect?: boolean;
}

export const GlassSurface = React.forwardRef<HTMLDivElement, GlassSurfaceProps>(
    ({ className, variant = 'card', hoverEffect = false, children, ...props }, ref) => {

        const baseStyles = "backdrop-blur-xl border border-white/[0.08] relative overflow-hidden transition-all duration-300";

        const variants = {
            panel: "bg-bg-surface/60 rounded-2xl shadow-[0_8px_32px_rgba(0,0,0,0.4)]",
            card: "bg-bg-surface border-bg-border rounded-card shadow-card-elite",
            elevated: "bg-bg-elevated border-white/[0.05] rounded-3xl shadow-2xl",
        };

        const hoverStyles = hoverEffect
            ? "hover:bg-bg-surface/80 hover:border-white/[0.12] hover:shadow-[0_12px_40px_rgba(0,0,0,0.5)] hover:-translate-y-0.5"
            : "";

        return (
            <div
                ref={ref}
                className={cn(baseStyles, variants[variant], hoverStyles, className)}
                {...props}
            >
                {/* Optional: Add subtle noise texture or gradient overlay here if needed */}
                {children}
            </div>
        );
    }
);

GlassSurface.displayName = 'GlassSurface';
